module.exports = __webpack_public_path__ + "img/genre1.b4259ede.svg";